import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import PageHeader from "../components/PageHeader";
import '../css/history.css';
import bgImage from "../assets/background-4.jpg";

export default function Cookies() {
  return (
    <>
      <Navbar />
      <PageHeader title="Cookies Notice" path="/cookies" name="Cookies" bgImage={bgImage} />
      <div className="history-page container-xxl py-5">
        <div className="container">
          <div className="history-intro">
            <h1>How We Use Cookies</h1>
            <p className="lead">
              This Notice explains what cookies are, how they are used on the Democratic Republic of the Yoruba (D.R.Y)
              website, and the choices available to you.
            </p>
          </div>

          <div className="history-section">
            <h3>1. What Are Cookies?</h3>
            <p>
              Cookies are small text files that a website places on your device when you visit it. They help the site
              remember information about your visit and support core functions.
            </p>
            <ul>
              <li>Some cookies are needed so that pages load correctly and forms work.</li>
              <li>Others remember your preferences, such as language or display settings.</li>
              <li>Analytics cookies help us understand how visitors use the site in an anonymous way.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>2. Types of Cookies We Use</h3>
            <p>
              The D.R.Y website aims to keep cookie use limited and respectful of your privacy.
            </p>
            <ul>
              <li>
                <strong>Essential cookies</strong> keep the site secure and ensure that navigation, forms and basic
                features function.
              </li>
              <li>
                <strong>Preference cookies</strong> remember choices you make so that pages feel familiar when you
                return.
              </li>
              <li>
                <strong>Analytics cookies</strong> provide aggregated statistics to improve content and performance.
              </li>
            </ul>
          </div>

          <div className="history-section">
            <h3>3. Why We Use Cookies</h3>
            <p>
              Cookies help us offer a stable, secure and useful experience for citizens and visitors.
            </p>
            <ul>
              <li>Maintain secure sessions while you complete forms or navigate between pages.</li>
              <li>Understand which pages are most helpful, so we can improve them.</li>
              <li>Support translations, media content and interactive features where available.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>4. Managing and Controlling Cookies</h3>
            <p>
              You are in control of how cookies are used on your device.
            </p>
            <ul>
              <li>Most browsers allow you to view, delete or block cookies in their settings menu.</li>
              <li>You can choose to block non‑essential cookies while still allowing core site functions.</li>
              <li>Blocking essential cookies may affect how the website works or prevent some services from loading.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>5. Third‑Party Cookies</h3>
            <p>
              Some pages may include content from other platforms, such as embedded videos or maps.
            </p>
            <ul>
              <li>These external services may set their own cookies on your device.</li>
              <li>We encourage you to read the cookie and privacy notices of those providers.</li>
              <li>The D.R.Y is not responsible for how third parties use information collected through their cookies.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>6. More Information</h3>
            <p>
              Cookies are only one part of how we protect and manage information on this website.
            </p>
            <ul>
              <li>Read the Privacy Policy to understand how personal data is collected and used.</li>
              <li>Review the Terms of Use for rules governing use of this website.</li>
              <li>Use the contact details in the footer if you have questions about cookies or privacy.</li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
      <BackToTop />
    </>
  );
}
